export default __webpack_public_path__ + "static/media/Hair_16_F_C4.76f8a1a7.svg";